module.exports = __webpack_public_path__ + "media/images/icons/twotone/car-d2962e2416b0734f1b2817fcd5a31e59.svg";